import React, { useContext, useEffect, useReducer, useState } from 'react'
import axios from 'axios'
import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'
import { useRazorPay } from '../../hooks/razorPay/useRazorPay'
import { toastMessage } from '../../shared/AlertPopup'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { API, backendUrl, tmpOrderUrl } from '../../shared/API'

export default function ActiveSubscriptions() {
  const { getAllSubscriptions, loading, paginate, updateSubscription, purchasedSubs,
     activeSubscriptions, subscriptionWithPurchases,
     deleteMany, pdfCsvData, active: activeSubs, downloadLoading } = useSubscription()
  const { loadRazorpay, purchaseSubscription, trySubscription} = useRazorPay()
  const { superAdmins, subscriptions, addSubscription } = useContext(SuperAdminContext)
  const [currentPrice, setCurrentPrice] = useState(0);
  const user = useContext(UserContext)
  //console.log('superAdmins : ', superAdmins)
  const history = useHistory()
  const token = user && user.token
  const header = formTokenHeader(token)
  const isCompanyAdmin = user && user.user.userType === 'COMPANYADMIN'
  const [searchQuery, setSearchQuery] = useState('')
  const [ text, setText] = useState("Renew")
  // const filterSuperAdmin = superAdmins
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllSubscriptions({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    subscriptionWithPurchases({
      page: page,
      limit: 10,
    })
    console.log("SUBSCRIPTIONS", subscriptions.subscriptions)
  }, [])


  const handleChange = (event, value) => {
    setPage(value)
  }

  const handleSwitchChange = (item) => updateSubscription({ ...item, active: !item.active})
  
  let tableBody = []

 const  valueOf = (x)=> { 
  if(!x) return "Purchased"
  return "Trial"
  }
  if (!loading && purchasedSubs) {
    tableBody = purchasedSubs.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id._id },
        { value: item._id.subscriptionName },
        { value: item.company.map((obj, index)=>{
          return obj.company.name+ " ( " + valueOf(obj.trial) + " ), "
        })},
      ]
    })
  }

  const layoutProps = {
    heading: 'Subscriptions',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // filename: 'subscriptions',
    // sheetName: 'subscriptions',
    // headers: pdfCsvData.headings,
    // // permission: "SUPERADMIN",
    // data: pdfCsvData.headingValues,
    // downloadLoading,
    // sampleName: 'subscriptions',
    // addData: addSubscription,
    setPage,
    tempHeaders : ["discount", "description", "active", "validityPeriod", "amount", "subscriptionName", "modules", "createdAt"],
    // tempHeaderData : ['2', '1', '3',  '1000', "TEMP_NAME", "AUDIT_EMPLOYEE", "01-01-2022"],

  }

  useEffect(() => {
      // loadScript("");
  });

  return (
    <CustomTableLayout
      tableHeadings={['Subscription Name', "Companies" ]}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteMany({ids:val}, setSelected) }
      // deleteMany={(val, setSelected) => deleteManySuperAdmin({ companyId: val }, setSelected)}
    />
  )
}
